import { render, staticRenderFns } from "./GateModal.vue?vue&type=template&id=b840e36a"
import script from "./GateModal.vue?vue&type=script&lang=js"
export * from "./GateModal.vue?vue&type=script&lang=js"
import style0 from "./GateModal.vue?vue&type=style&index=0&id=b840e36a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports